import { FC } from 'react'

import { get } from 'lodash'
import { Checkbox } from 'components/Forms'
import { Accordion, Button as MerinioButton } from 'ui'

import { t } from 'translations'

type Props = {
  name: string
  content: { translation: string; permissions: Record<string, { translation: string }> }
  isEditable: boolean
  values: { permissions: MStore.Permissions }
  setFieldValue: (field: string, value: Record<string, string>) => void
}

const PermissionsItem: FC<Props> = ({ name, content, values, setFieldValue, isEditable }) => {
  const allPermissionKeys = Object.keys(content.permissions)
  const selectedPermissionKeys = Object.keys(values.permissions[name] ?? {}).filter(key => values.permissions[name][key] && allPermissionKeys.includes(key))

  return (
    <Accordion
      Trigger={
        <MerinioButton type="button" isLink>
          {t(`administration.permissions.permissionsKey.${content.translation}`)}
        </MerinioButton>
      }
    >
      <span className="d-flex justify-content-end align-items-baseline">
        {isEditable ? (
          <>
            {selectedPermissionKeys.length === allPermissionKeys.length ? (
              <MerinioButton
                isLink
                type="button"
                onClick={() =>
                  setFieldValue(
                    `permissions.${name}`,
                    allPermissionKeys.reduce((acc, key) => ({ ...acc, [key]: false }), {})
                  )
                }
              >
                {t(`administration.permissions.ADMIN.UNSELECT_ALL`)}
              </MerinioButton>
            ) : (
              <MerinioButton
                isLink
                type="button"
                onClick={() =>
                  setFieldValue(
                    `permissions.${name}`,
                    allPermissionKeys.reduce((acc, key) => ({ ...acc, [key]: true }), {})
                  )
                }
              >
                {t(`administration.permissions.ADMIN.SELECT_ALL`)}
              </MerinioButton>
            )}
          </>
        ) : null}
        <span className="pt-2">
          {selectedPermissionKeys.length}/{allPermissionKeys.length}
        </span>
      </span>
      {allPermissionKeys.map(key =>
        isEditable ? (
          <Checkbox
            key={`${name}-${key}`}
            module=""
            name={`permissions.${name}.${key}`}
            label={`administration.permissions.permissionsKey.${content.permissions[key].translation}`}
            noDescription
          />
        ) : (
          <div key={`${name}-${key}`}>
            <i className={`${get(values, `permissions.${name}.${key}`, false) ? 'fas fa-check-circle' : 'far fa-circle'}`} />{' '}
            {t(`administration.permissions.permissionsKey.${content.permissions[key].translation}`)}
          </div>
        )
      )}
    </Accordion>
  )
}

export default PermissionsItem
